import Vue from "vue";
import router from "@/router";
import * as constants from "@/utils/Constants";
import { BrowserTracing } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";

if (constants.SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: constants.SENTRY_DSN,
    environment: constants.GLOBAL_ENV,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

Sentry.setTag("platform", "frontend");
